import type { JSX } from "react";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { TooltipPortalProps } from "./Tooltip.types";

export function TooltipPortal({
  children,
  ...props
}: TooltipPortalProps): JSX.Element {
  const container = useFloatingPortalContainer();

  return (
    <BaseTooltip.Portal
      data-slot="tooltip-portal"
      container={container}
      {...props}
    >
      {children}
    </BaseTooltip.Portal>
  );
}
